import {useDisclosure} from '@chakra-ui/react'

/**
 * Hook for managing the open/close state of the AccountModal
 */
export const useAccountModal = () => {
    const {isOpen, onOpen, onClose} = useDisclosure()

    return {
        isOpen,
        onOpen,
        onClose
    }
}
